/* eslint-disable import/prefer-default-export */
export const SITE_TITLE = 'https://ourfriendselectric.com.au'
export const KEYWORDS = 'experiential, streaming, broadcast, design, digital'
